import React, { Component, Fragment } from "react";
import { Link, NavLink } from "react-router-dom";
import * as Scroll from "react-scroll";
import * as auth from "imports/auth";
import UserLoginBtn from "./components/UserLoginBtn";
import UserNavigation from "./components/UserNavigation";
import "./NavBar.scss";
import history from "imports/history";
import MobileSidebar from "../mobile-sidebar/MobileSidebar";
import * as authUser from "../../imports/auth";
import Modal from "react-modal";
import { sendBru_api } from "../../pages/home/HomeApi";


const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)"
    }
};


export default class NavBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNumber: "",
            activeBtn: true,
            modalBruIsOpen: false,
            mobileNumber: "",
            sendStatus:"default",
            spin:false
        };

    }

    componentDidMount() {
        window.scrollTo(0, 0);
        if (authUser.isLogin() === true) {
            this.props.initData();
        }
    }

    state = {
        isMenuOpen: false
    };

    handleClickOnCourse(e) {
        e.preventDefault();
        if (this.props.isHome) {
            Scroll.scroller.scrollTo("mba", {
                duration: 500,
                smooth: true,
                offset: 50
            });
        } else {
            history.push({
                pathname: "/home",
                search: "?go=mba"
            });
        }
    }

    toggleHamburgerMenu() {
        this.setState({
            isMenuOpen: !this.state.isMenuOpen
        });
    }

    toggleHamburgerMenu() {
        this.setState({
            isMenuOpen: !this.state.isMenuOpen
        });
    }

    openModal() {
        this.setState({ sendStatus: "default" });
        this.setState({ mobileNumber: "" });
        this.setState({ modalBruIsOpen: true });
    }

    closeModal() {
        this.setState({ modalBruIsOpen: false });
    }

    setMobileNumber(e) {
        this.setState({ mobileNumber: e.target.value });
    }

    async sendBru(e) {
        this.setState({ spin: true });
        if(this.state.mobileNumber.length > 5) {
            try{
                const res = await sendBru_api(this.state.mobileNumber);
                this.setState({ sendStatus: "success" });
            }catch (e) {
                this.setState({ sendStatus: "error" });
            }
        }
    }

    render() {
        const user = auth.getUser();
        const userIsSignedIn = user !== null && user !== undefined;
        return (
            <Fragment>
                <MobileSidebar
                    unSeenMessages={this.props.unSeenMessages}
                    notifications={this.props.notifications}
                    open={this.state.isMenuOpen}
                    onClickOverlay={() => {
                        this.toggleHamburgerMenu();
                    }}
                />
                <Modal
                    isOpen={this.state.modalBruIsOpen}
                    onRequestClose={e => this.closeModal()}
                    contentLabel="ضمیمه"
                    style={customStyles}
                    className=""
                >

                    <div className="float-register-modal">
                        <div className="float-register-modal-title"><span>برای دریافت بروشور لطفا شماره همراه خود را وارد نمایید</span>
                        </div>
                        <div className="bru-mobile-input"><span className="icon icon-mobile"></span>
                            <input type="text"
                                   name="" id=""
                                   placeholder="شماره موبایل"
                                   onChange={e=>this.setMobileNumber(e)}
                                   value={this.mobileNumber}
                            />
                        </div>
                        {this.state.sendStatus==="error"?
                            <div className="float-modal-error-message">
                                <span>مشکل در ارسال , مجددا سعی نمایید</span>
                            </div>:null
                        }

                        {this.state.sendStatus==="success"?
                            <div className="float-modal-success-message">
                                <span>بروشور با موفقیت برای شما ارسال شد</span>
                            </div>:null}

                        <div className="float-bru-modal-btn" onClick={e=>{
                            this.sendBru()
                        }}><span>ارسال بروشور</span></div>
                    </div>
                </Modal>
                <header id="header">
                    <div
                        onClick={this.props.hideNotifsList}
                        className={
                            this.props.showNotifsList === true
                                ? "outer-page"
                                : ""
                        }
                    ></div>
                    <div className="dr-container dr-padding">
                        <nav
                            onClick={this.props.hideNotifsList}
                            id="nav-menu-container"
                        >
                            <button
                                type="button"
                                id="mobile-nav-toggle"
                                onClick={e => {
                                    e.preventDefault();
                                    this.toggleHamburgerMenu();
                                }}
                            >
                                <i className="icon icon-navicon"></i>
                            </button>
                            <ul className="nav-menu clearfix">
                                <li>
                                    <Link to="/home">
                                        <img
                                            src="/images/logo.svg"
                                            className="logo"
                                            alt="derayat-logo"
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <NavLink
                                        activeClassName="active"
                                        exact
                                        to="/home"
                                    >
                                        خانه
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        activeClassName="active"
                                        exact
                                        to="/programs"
                                    >
                                        دوره ها
                                    </NavLink>
                                </li>
                                {/* <li>
                                    <NavLink
                                        activeClassName="active"
                                        to="/mba-program"
                                    >
                                        دوره MBA
                                    </NavLink>
                                </li> */}
                                <li>
                                    <NavLink
                                        activeClassName="active"
                                        to="/courses"
                                    >
                                        درس‌ها
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink activeClassName="active" to="/faq">
                                        سوالات متداول
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        activeClassName="active"
                                        to="/about-us"
                                    >
                                        درباره‌ ما
                                    </NavLink>
                                </li>
                                <li>
                                        <span className="send-bru-btn" onClick={e=>{
                                            this.openModal();
                                        }}>
                                            دریافت بروشور
                                        </span>
                                </li>
                                <li>
                                    <NavLink
                                        activeClassName="active"
                                        to="/contact"
                                    >
                                        تماس با ما
                                    </NavLink>
                                </li>
                            </ul>
                        </nav>
                        <div className="logo-container-mobile">
                            <Link to="/home">
                                <img
                                    src="/images/logo.svg"
                                    className="logo"
                                    alt="derayat-logo"
                                />
                            </Link>
                        </div>
                        <div id="userInfo-logo">
                            {userIsSignedIn ? (
                                <UserNavigation
                                    onClick={this.props.hideNotifsList}
                                    unSeenMessages={this.props.unSeenMessages}
                                    fullName={
                                        user.firstName + " " + user.lastName
                                    }
                                    unSeenNotifs={this.props.notifsCount}
                                    notifications={this.props.notifications}
                                    toggleNotifsList={
                                        this.props.toggleNotifsList
                                    }
                                    showNotifsList={this.props.showNotifsList}
                                    image={user.image}
                                />
                            ) : (
                                <UserLoginBtn />
                            )}
                        </div>
                    </div>
                </header>
            </Fragment>
        );
    }
}
